"use client";

import { useEffect } from "react";
import { flushClientTelemetry } from "@/lib/analytics/client";
import type { LoadErrorRecoveryKind } from "@/lib/load-error-recovery";
import { scheduleLoadErrorRecovery } from "@/lib/load-error-recovery.client";

/**
 * Recover once per browser session from an incoherent client deployment.
 * Repeating the same reload forever is worse than leaving a manual fallback,
 * so the signature remains in sessionStorage after the first attempt.
 */
export function useLoadErrorRecovery({
  error,
  recoveryKind,
}: {
  error: Error & { digest?: string };
  recoveryKind: LoadErrorRecoveryKind | null;
}) {
  useEffect(() => {
    scheduleLoadErrorRecovery(error, recoveryKind, flushClientTelemetry);
  }, [error, recoveryKind]);
}
